import React, { memo } from 'react'

import { bool } from 'prop-types'

import AdvancedFiltersContent from 'Pods/SearchPage/Shared/AdvancedFiltersContent/AdvancedFiltersContent'
import DatePublishedContent from 'Pods/SearchPage/Shared/DatePublishedContent/DatePublishedContent'
import DesignerContent from 'Pods/SearchPage/Shared/DesignerContent/DesignerContent'
import LicenseContent from 'Pods/SearchPage/Shared/LicenseContent/LicenseContent'
import PopoverFeaturesContent from 'Pods/SearchPage/Shared/PopoverFeaturesContent/PopoverFeaturesContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { DATE_PUBLISHED } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

// Figma 2807:161222 (1600): Date published | General + My Library | Designer.
// Figma 2807:160650 (1920): Date published has its own row 1 dropdown, so it drops out.
// License has no row 1 dropdown at any width, so it gets its own column after Date published.
function Columns({ showDatePublished = false }) {
  const translate = useTranslate()

  // The custom-range calendar is drawn 272px wide (Figma 2807:161786); in the 200px column its day
  // cells shrink under the 40px selection circles.
  const isCustomRange = useSearchPageStore(state => state.datePublished === DATE_PUBLISHED.CUSTOM)

  return (
    <div className="more-filters__columns">
      {showDatePublished && (
        <div
          className={isCustomRange
            ? 'more-filters__column more-filters__column--calendar'
            : 'more-filters__column'}
        >
          <div className="more-filters__column-title cgt-overline-md">
            {translate('search_page.filters.date_published.title')}
          </div>
          <DatePublishedContent />
        </div>
      )}
      <div className="more-filters__column">
        <div className="more-filters__column-title cgt-overline-md">
          {translate('search_page.filters.license.title')}
        </div>
        <LicenseContent />
      </div>
      <div className="more-filters__column">
        <PopoverFeaturesContent />
        <AdvancedFiltersContent />
      </div>
      <div className="more-filters__column more-filters__column--wide">
        <div className="more-filters__column-title cgt-overline-md">
          {translate('search_page.filters.designers.title')}
        </div>
        {/* The popover's footer Reset clears designers, so the section hides its own. The list
            scrolls on its own so a long one does not stretch every column. */}
        <DesignerContent hideReset isListScrollable />
      </div>
    </div>
  )
}

Columns.propTypes = {
  showDatePublished: bool,
}

export default memo(Columns)
